import {createContext} from "react";

export const ScreenSizeContext = createContext({
    isMobile: null,
    isRetina: false
});
